// File: frontend/src/components/SectionSubnav.js
// Version: 1.0 (quick-260908-pun, окно 1)
// Date: 2026-09-08
// Назначение: полоса подраздела для арендатора fitenko.
//
// 🔴 ЭТО И ЕСТЬ ДОСТИЖИМОСТЬ СВЁРНУТОГО. Меню сведено с 20 пунктов в 9 разделов;
//    пункт раздела ведёт на ПЕРВОЕ ВИДИМОЕ назначение, а все остальные назначения
//    того же раздела живут здесь. Без этой полосы сведение стало бы удалением
//    страниц: Tasks, My Portal, Doc Generator, Voice AI, AI Staff, Brain Center,
//    Organic SEO, SEO Analytics, Users, Audit Log, Company Profile и Magic Deploy
//    потеряли бы единственный вход.
//
// 🔴 Своих меток компонент НЕ содержит: держатель меток ОДИН — модель навигации.

import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';
import { subnavFor } from '../config/fitenkoNav';

const SectionSubnav = () => {
    const { user, navLinks, isAuthenticated, loading } = useAuth();
    const { isFitenko } = useBranding();
    const location = useLocation();

    if (!isFitenko) return null;   // РУБЕЖ АРЕНДАТОРА
    if (loading || !isAuthenticated) return null;

    const items = subnavFor(user, navLinks, location.pathname);
    // Пустой список — полосы НЕТ, а не пустая полоса.
    if (!items || items.length === 0) return null;

    return (
        <nav className="section-subnav bg-card text-foreground border-b border-border">
            {items.map(item => (
                <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) => `section-subnav-item text-foreground hover:bg-muted ${isActive ? 'active nav-item--active' : ''}`}
                >
                    <span className="section-subnav-item-icon">{item.icon}</span>
                    {item.label}
                </NavLink>
            ))}
        </nav>
    );
};

export default SectionSubnav;
